<script setup>
import { computed } from 'vue';
import SportLiveTvEmpty from '@/sport-live-tv/components/sport-live-tv-empty.vue';
import SportLiveTvRow from '@/sport-live-tv/components/sport-live-tv-row.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

const props = defineProps({
  featured: { type: Array, required: true },
  live: { type: Array, required: true },
  categories: { type: Array, required: true },
  scoresVisible: { type: Boolean, default: false },
});

const emit = defineEmits(['select', 'select-category', 'show-live']);

const { t } = useSportLiveTvTranslation();

const isEmpty = computed(() => !props.featured.length && !props.live.length && !props.categories.length);
</script>

<template>
  <SportLiveTvEmpty v-if="isEmpty" />
  <div v-else class="sport-live-tv-rows">
    <SportLiveTvRow v-if="featured.length" :title="t('featured')" :events="featured" :scores-visible="scoresVisible" @select="emit('select', $event)" />
    <SportLiveTvRow v-if="live.length" :title="t('liveGames')" :events="live" :scores-visible="scoresVisible" title-clickable @title-click="emit('show-live')" @select="emit('select', $event)" />
    <SportLiveTvRow
      v-for="category in categories"
      :key="category.id"
      :title="category.name"
      :events="category.events"
      :scores-visible="scoresVisible"
      title-clickable
      @title-click="emit('select-category', category.id)"
      @select="emit('select', $event)"
    />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-rows {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
